import { DateFormats, DateTimeFormats } from '../../store/shared/const';
import LocalizedStrings, { LocalizedStrings as strings } from 'react-localization';

import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import Moment from 'moment';

export class WebI18n implements Ii18n {

  private readonly strings: strings<{ [key: string]: string }>;

  constructor() {
    this.strings = new LocalizedStrings({
      fr: require('../../assets/i18n/fr.json'),
      nl: require('../../assets/i18n/nl.json')
    });
  }

  get(key: string): string {
    return this.strings[key];
  }

  setLanguage(languageCode: string): void {
    this.strings.setLanguage(languageCode);
  }

  getLanguage(): string {
    return this.strings.getLanguage();
  }

  getInterfaceLanguage(): string {
    return this.strings.getInterfaceLanguage();
  }

  formatString(key: string, values: { [key: string]: string }): string | string[] {
    return this.strings.formatString(this.strings[key], values);
  }

  getHours(time: string): number {
    return +time.slice(0, 2);
  }

  getMinutes(time: string): number {
    return +time.slice(3, 5);
  }

  getFormatedDate(date: Date | string | '', currentLanguage: string): string {
    const language = currentLanguage.slice(0, 2);
    if (typeof date === 'string') {
      date = new Date(date); // Convert string to Date
    }
    if (!date) {
      return '';
    }
    if (Moment(date).isValid()) {
      return Moment(date).format(DateFormats[language as keyof typeof DateFormats]);
    }
    return Moment(date.toString().substr(0, 10), DateFormats.iso, true).format(DateFormats[language as keyof typeof DateFormats]);
  }

  getFormatedDateTime(date: Date | '', currentLanguage: string): string {
    const language = currentLanguage.slice(0, 2);
    if (!date) {
      return '';
    }
    if (Moment(date).isValid()) {
      return Moment(date).format(DateTimeFormats[language as keyof typeof DateFormats]);
    }
    return Moment(date.toString(), DateTimeFormats.iso, true).format(DateTimeFormats[language as keyof typeof DateFormats]);
  }
}
